#import "~/graphql/fragments/Entry/ProjectHero.graphql"
#import "~/graphql/fragments/Assets/DefaultImageAsset.graphql"

fragment DetailCard on detail_Entry {
    title

    dateRange {
        start
        end
    }

    projectHero {
        ... ProjectHero
    }

    postDate

    sectionHandle

    parent {
        title
    }

    neighbourhoodRelation {
        ... on category_Entry {
            title
            slug
        }
    }

    # Card Details
    cardDetails {
        title: cardTitle
        description: cardDescription
        image: cardImage {
            ... DefaultImageAsset
        }
    }
}
